import React from 'react';
import {ListItem} from '@mui/material';
import MuiTypography from '@new-components/atoms/MuiTypography';
import Link from 'next/link';

interface NavMenuItem {
  sx?: Record<string, any>;
  label: string;
  link: string;
  description?: string;
  query?: Record<string, string>;
  onClick: () => void;
  transparent: boolean;
}

const NavMenuItem: React.FC<NavMenuItem> = (props) => {
  return (
    <ListItem
      key={props.label}
      onClick={props.onClick}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '24px 0 !important', // !important is added because the li style in the reset file affects the padding
        borderBottom: '1px solid #82807E1A',
        ['&:last-child']: {
          borderBottom: 'none',
        },
        ...props.sx,
      }}>
      <Link
        href={{pathname: props.link, query: props.query ?? {}}}
        prefetch={false}
        style={{textDecoration: 'none'}}>
        <MuiTypography
          variant='body1'
          sx={{
            color: props.transparent ? '#FFFFFF' : '#FFFFFF',
            transition: 'color 0.3s',
            textDecoration: 'none',
            width: 'fit-content',
            fontSize: '22px',
            fontWeight: 300,
            lineHeight: '27.5px',
            letterSpacing: '-0.4000000059604645px',
            textAlign: 'left',
            textUnderlinePosition: 'from-font',
            textDecorationSkipInk: 'none',
            ['&:hover']: {
              textDecoration: 'none',
              color: '#FFA629',
              transition: 'color 0.3s',
            },
            ['&:after']: {
              content: '""',
              display: 'block',
              width: '0%',
              height: '2px',
              background: '#FFA629',
              marginTop: '-4px',
              transition: 'width 0.3s',
            },
            ['&:hover:after']: {
              width: '100%',
            },
          }}>
          {props.label}
        </MuiTypography>
        <MuiTypography
          variant='body2'
          sx={{
            marginTop: '4px',
            color: props.transparent ? '#FFFFFFBF' : '#FFFFFFBF',
            fontSize: '13px',
            fontWeight: 300,
            lineHeight: '16.25px',
            textAlign: 'left',
            textUnderlinePosition: 'from-font',
            textDecorationSkipInk: 'none',
          }}>
          {props.description}
        </MuiTypography>
      </Link>
    </ListItem>
  );
};

export default NavMenuItem;
export type {NavMenuItem};
